import { jsx as a, jsxs as s } from "react/jsx-runtime";
import * as n from "react";
import * as e from "@radix-ui/react-accordion";
import { ChevronDown as l } from "lucide-react";
import { cn as i } from "../../../lib/utils.js";
const b = e.Root, c = n.forwardRef(({ className: r, ...t }, o) => a(e.Item, { ref: o, className: i("border border-border-color bg-surface backdrop-blur-md shadow-luxury rounded-2xl mb-4 overflow-hidden group", r), ...t }));
c.displayName = "AccordionItem";
const m = n.forwardRef(({ className: r, children: t, ...o }, d) => a(e.Header, { className: "flex", children: s(e.Trigger, { ref: d, className: i("flex flex-1 items-center justify-between py-4 px-6 text-sm font-semibold text-text-primary transition-all hover:bg-border-color [&[data-state=open]>svg]:rotate-180 [&[data-state=open]]:text-lpr-teal dark:[&[data-state=open]]:text-lpr-gold", r), ...o, children: [t, a(l, { className: "h-4 w-4 shrink-0 transition-transform duration-300 text-lpr-gold dark:text-lpr-neutral" })] }) }));
m.displayName = e.Trigger.displayName;
const p = n.forwardRef(({ className: r, children: t, ...o }, d) => a(e.Content, { ref: d, className: "overflow-hidden text-[13px] font-medium transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down", ...o, children: a("div", { className: i("pb-5 pt-2 px-6 text-text-secondary leading-relaxed", r), children: t }) }));
p.displayName = e.Content.displayName;
export {
  b as Accordion,
  p as AccordionContent,
  c as AccordionItem,
  m as AccordionTrigger
};
//# sourceMappingURL=Accordion.js.map
